import React, { useEffect } from "react";
import { useTheme, useMediaQuery } from "@mui/material";

const SupportPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const widgetId = 89000000906;
  const scriptId = "freshworks-widget";

  // Function to load Freshworks widget
  const loadWidget = () => {
    // Avoid duplicate load
    if (document.getElementById(scriptId)) return;

    window.fwSettings = { widget_id: widgetId };

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = `https://ind-widget.freshworks.com/widgets/${widgetId}.js`;
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

  };

  // Function to remove Freshworks widget
  const removeWidget = () => {
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.remove();
    }

    if (window.FreshworksWidget) {
      try {
        window.FreshworksWidget("destroy");
      } catch {
      }
    }
  };

  useEffect(() => {
    if (!isMobile) {
      loadWidget();
    } else {
      removeWidget();
    }

    // Cleanup on unmount
    return () => {
      removeWidget();
    };
  }, [isMobile]); // 👈 re-run when screen size changes

  return null;
};

export default SupportPage;
